import {Component, inject} from '@angular/core';
import {HasPermissionDirective} from "../../../directives/permissions/has-permission";
import {MatDivider} from "@angular/material/divider";
import {MatIcon} from "@angular/material/icon";
import {MatIconButton} from "@angular/material/button";
import {MatMenu, MatMenuItem, MatMenuTrigger} from "@angular/material/menu";
import {MatTooltip} from "@angular/material/tooltip";
import {ICellRendererAngularComp} from "ag-grid-angular";
import {PermissionTypes} from "../../../enum/PermissionTypes";
import {Router} from "@angular/router";
import {UsersService} from "../../../services/users.service";
import {ICellRendererParams} from "ag-grid-community";
import {ICharityAdmin} from "../../../interfaces/ICharityAdmin";
import {SnackbarService} from "../../../services/snackbar.service";
import {UIStateEnum} from "../../../enum/UIStateEnum";
import {MatProgressSpinner} from "@angular/material/progress-spinner";

@Component({
  selector: 'app-charity-admin-settings',
  standalone: true,
  imports: [
    HasPermissionDirective,
    MatDivider,
    MatIcon,
    MatIconButton,
    MatMenu,
    MatMenuItem,
    MatTooltip,
    MatMenuTrigger,
    MatProgressSpinner
  ],
  templateUrl: './charity-admin-settings.component.html',
  styleUrl: './charity-admin-settings.component.scss'
})
export class CharityAdminSettingsComponent implements ICellRendererAngularComp {

  public adminUser!: ICharityAdmin;
  public permissionTypes = PermissionTypes;
  public gameId: string = '';
  public isCrossGame: boolean = false;
  public uiState = UIStateEnum.ShowData;
  public uiStateEnumForTemplate = UIStateEnum;

  private snackBarService: SnackbarService = inject(SnackbarService);

  constructor(private router: Router,
              private userService: UsersService) {
  }

  agInit(params: ICellRendererParams & {
    gameId: string,
    isCrossGame: boolean
  }): void {
    this.adminUser = params.data;
    this.gameId = params.gameId;
    this.isCrossGame = params.isCrossGame;
  }

  onDeactivateUserClick() {
    this.userService.onDeactivateUserClick(this.adminUser, this.gameId);
  }

  async onViewDetailsClick() {
    if (this.isCrossGame) {
      await this.router.navigateByUrl(`cross-game-user-details/${this.adminUser.Id}`);
    } else {
      await this.router.navigateByUrl(`${this.gameId}/game-admin-user-details/${this.adminUser.Id}`);
    }
  }

  onReactiveUserClick() {
    this.userService.onReactivateUserClick(this.adminUser, this.gameId);
  }

  refresh(_params: ICellRendererParams): boolean {
    return false;
  }

  onResendInviteClick() {
    this.uiState = UIStateEnum.ShowLoading;
    this.userService.resendCharityAdminInvite({
      targetAdminId: this.adminUser.Id,
      gameId: this.gameId,
      redirectUrl: `${window.location.origin}/login`,
      charityIds: this.adminUser.Charities.map(charity => charity.Id)
    }).subscribe({
      next: () => {
        this.uiState = UIStateEnum.ShowData;
        this.snackBarService.openSuccessfulSnackBar("Successfully resent email");
      },
      error: err => {
        this.uiState = UIStateEnum.ShowData;
        this.snackBarService.openErrorSnackBar("Looks like there was an error resending the email. Please try again or contact a system admin");
      }
    })
  }

}
